// extracted by mini-css-extract-plugin
module.exports = {"root":"Input_root__1Psed"};